import React from 'react';
import { SHOW_THUMBNAIL_IMAGE } from 'helpers/ImageHelper';
import Image from 'components/Tile/components/Image';
import theme from './style.css';

// if we wanted to use themr here we could create a new wrapper around the Image component
const ShowsTileImage = props => <Image imageType={SHOW_THUMBNAIL_IMAGE} {...props} theme={theme} />;

export default ShowsTileImage;
